var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 468.293 468.293",
    style: {
      enableBackground: "new 0 0 468.293 468.293"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#44C4A1"
    },
    points: "113.129,184.779 0,153.768 0,382.887 113.129,208.443  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M113.129,10.709l-87.43,21.677C11.506,35.906,0,50.265,0,64.458v41.456l113.129,31.011V10.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M442.594,8.632L296.907,41.487v222.16l22.055,6.54L468.293,43.27V28.536 C468.293,14.343,456.787,5.431,442.594,8.632z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#44C4A1"
    },
    points: "468.293,314.471 468.293,83.849 341.306,276.814  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M296.907,352.08v108.232l145.687-32.855c14.193-3.201,25.699-17.302,25.699-31.495v-33.637 l-149.042-44.198L296.907,352.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M0,423.466v8.418c0,14.193,11.506,22.846,25.699,19.327l87.43-21.677V249.023L0,423.466z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C358"
    },
    points: "113.129,136.925 0,105.914 0,153.768 113.129,184.779  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C358"
    },
    points: "113.129,208.443 0,382.887 0,423.466 113.129,249.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C358"
    },
    points: "296.907,263.647 296.907,311.501 296.907,352.08 319.251,318.126 468.293,362.325  468.293,314.471 341.306,276.814 468.293,83.849 468.293,43.27 318.962,270.187  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3EA69B"
    },
    points: "113.129,184.779 113.129,208.443 126.159,193.702  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3EA69B"
    },
    points: "151.091,162.921 263.941,35.249 113.129,10.709 113.129,136.925  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3EA69B"
    },
    points: "173.434,178.222 296.907,262.772 296.907,40.612 295.3,40.351  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3EA69B"
    },
    points: "213.269,445.828 296.907,459.437 296.907,351.205  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3EA69B"
    },
    points: "296.907,310.626 148.503,209.003 113.129,249.023 113.129,429.534 181.912,440.726  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C358"
    },
    points: "295.3,40.351 263.941,35.249 151.091,162.921 113.129,136.925 113.129,184.779  126.159,193.702 113.129,208.443 113.129,249.023 148.503,209.003 296.907,310.626 296.907,262.772 173.434,178.222  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C358"
    },
    points: "213.269,445.828 296.907,351.205 296.907,310.626 181.912,440.726  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE412D"
    },
    d: "M105.466,72.149c0,20.379-36.9,82.045-36.9,82.045c1.411,0-36.9-61.665-36.9-82.045 s16.521-36.9,36.9-36.9S105.466,51.769,105.466,72.149z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 68.564,
    cy: 72.18,
    r: 21.317
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE412D"
    },
    d: "M378.206,307.087c0,20.379-36.9,82.044-36.9,82.044c1.411,0-36.9-61.665-36.9-82.044 s16.521-36.9,36.9-36.9C361.686,270.187,378.206,286.708,378.206,307.087z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 341.292,
    cy: 307.088,
    r: 21.317
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.35ca804de839876b655a4f7b43a8b521.svg";
export { ForwardRef as ReactComponent };